module.exports = __webpack_public_path__ + "img/affiliate_close_button.fe7c1d22.png";